import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface BlockingOverlayProps {
  open: boolean;
  mensaje?: string;
}

// SPEC-126 (RNF-004) — bloquea la pantalla mientras se genera el PDF de la cotización
// (al convertir o al guardar una bolsa en BORRADOR), evitando interacción concurrente.
export const BlockingOverlay: React.FC<BlockingOverlayProps> = ({
  open,
  mensaje = 'Generando cotización...',
}) => {
  if (!open) return null;

  return (
    <Box
      data-testid="blocking-overlay"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        backgroundColor: 'rgba(33, 28, 31, 0.45)',
      }}
    >
      <CircularProgress sx={{ color: '#fff' }} />
      <Typography sx={{ fontFamily: 'Poppins, sans-serif', color: '#fff', fontWeight: 600 }}>
        {mensaje}
      </Typography>
    </Box>
  );
};
